import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import styled from '@emotion/styled'; // eslint-disable-next-line no-restricted-imports

import { format, isValid, lastDayOfMonth, parse } from 'date-fns';
import pick from 'lodash/pick';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import Calendar from '@atlaskit/calendar';
import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import { createLocalizationProvider } from '@atlaskit/locale';
import Select, { mergeStyles } from '@atlaskit/select';
import { B100, N20 } from '@atlaskit/theme/colors';
import { borderRadius, gridSize, layers } from '@atlaskit/theme/constants';
import { e200 } from '@atlaskit/theme/elevation';
import { defaultDateFormat, EmptyClearIndicator, padToTwo, placeholderDatetime } from '../internal';
import FixedLayer from '../internal/FixedLayer';
var packageName = "@atlaskit/datetime-picker";
var packageVersion = "10.4.2";
/* eslint-disable react/no-unused-prop-types */

function getDateObj(date) {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
}

function getValidDate(iso) {
  var date = parse(iso);
  return isValid(date) ? getDateObj(date) : {};
}

var StyledMenu = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", "px;\n  z-index: ", ";\n  ", ";\n"])), N20, borderRadius(), layers.dialog, e200());

var Menu = function Menu(_ref) {
  var selectProps = _ref.selectProps,
      innerProps = _ref.innerProps;
  return /*#__PURE__*/React.createElement(FixedLayer, {
    inputValue: selectProps.inputValue,
    containerRef: selectProps.calendarContainerRef,
    content: /*#__PURE__*/React.createElement(StyledMenu, innerProps, /*#__PURE__*/React.createElement(Calendar, _extends({}, getValidDate(selectProps.calendarValue), getValidDate(selectProps.calendarView), {
      disabled: selectProps.calendarDisabled,
      disabledDateFilter: selectProps.calendarDisabledDateFilter,
      minDate: selectProps.calendarMinDate,
      maxDate: selectProps.calendarMaxDate,
      onChange: selectProps.onCalendarChange,
      onSelect: selectProps.onCalendarSelect,
      calendarRef: selectProps.calendarRef,
      selected: [selectProps.calendarValue],
      locale: selectProps.calendarLocale,
      testId: selectProps.testId && "".concat(selectProps.testId, "--calendar"),
      weekStartDay: selectProps.calendarWeekStartDay
    }))),
    testId: selectProps.testId
  });
};

var datePickerDefaultProps = {
  appearance: 'default',
  autoFocus: false,
  defaultIsOpen: false,
  defaultValue: '',
  disabled: [],
  disabledDateFilter: function disabledDateFilter(_) {
    return false;
  },
  hideIcon: false,
  icon: CalendarIcon,
  id: '',
  innerProps: {},
  isDisabled: false,
  isInvalid: false,
  name: '',
  onBlur: function onBlur(event) {},
  onChange: function onChange(value) {},
  onFocus: function onFocus(event) {},
  selectProps: {},
  spacing: 'default',
  locale: 'en-US' // Not including a default prop for value as it will
  // Make the component a controlled component

};

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "calendarRef", null);

    _defineProperty(_assertThisInitialized(_this), "containerRef", null);

    _defineProperty(_assertThisInitialized(_this), "getSafeState", function () {
      return _objectSpread(_objectSpread(_objectSpread({}, _this.state), pick(_this.props, ['value', 'isOpen'])), pick(_this.props.selectProps, ['inputValue']));
    });

    _defineProperty(_assertThisInitialized(_this), "isDateDisabled", function (date) {
      return _this.props.disabled.indexOf(date) > -1;
    });

    _defineProperty(_assertThisInitialized(_this), "onCalendarChange", function (_ref2) {
      var iso = _ref2.iso;

      var _iso$split = iso.split('-'),
          _iso$split2 = _slicedToArray(_iso$split, 3),
          year = _iso$split2[0],
          month = _iso$split2[1],
          date = _iso$split2[2];

      var newIso = iso;
      var parsedDate = parseInt(date, 10);
      var parsedMonth = parseInt(month, 10);
      var parsedYear = parseInt(year, 10);
      var lastDayInMonth = lastDayOfMonth(new Date(parsedYear, parsedMonth - 1)).getDate();

      if (lastDayInMonth < parsedDate) {
        newIso = "".concat(year, "-").concat(padToTwo(parsedMonth), "-").concat(padToTwo(lastDayInMonth));
      } else {
        newIso = "".concat(year, "-").concat(padToTwo(parsedMonth), "-").concat(padToTwo(parsedDate));
      }

      _this.setState({
        view: newIso
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCalendarSelect", function (_ref3) {
      var iso = _ref3.iso;

      _this.setState({
        inputValue: '',
        isOpen: false,
        selectedValue: iso,
        view: iso,
        value: iso
      });

      _this.props.onChange(iso);
    });

    _defineProperty(_assertThisInitialized(_this), "onInputClick", function () {
      if (!_this.props.isDisabled && !_this.getSafeState().isOpen) {
        _this.setState({
          isOpen: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectBlur", function (event) {
      if (_this.getSafeState().clearingFromIcon) {
        // Don't close menu if blurring after the user has clicked clear
        _this.setState({
          clearingFromIcon: false
        });
      } else {
        _this.setState({
          isOpen: false
        });
      }

      _this.props.onBlur(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectFocus", function (event) {
      var _this$getSafeState = _this.getSafeState(),
          clearingFromIcon = _this$getSafeState.clearingFromIcon,
          value = _this$getSafeState.value;

      if (clearingFromIcon) {
        // Don't open menu if focussing after the user has clicked clear
        _this.setState({
          clearingFromIcon: false
        });
      } else {
        _this.setState({
          isOpen: true,
          view: value
        });
      }

      _this.props.onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectInput", function (event) {
      var value = event.target.value;

      if (value) {
        var parsed = _this.parseDate(value); // Only try to set the date if we have month & day


        if (parsed && isValid(parsed)) {
          // We format the parsed date to YYYY-MM-DD here because
          // this is the format expected by the @atlaskit/calendar component
          _this.setState({
            view: format(parsed, 'YYYY-MM-DD')
          });
        }
      }

      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectKeyDown", function (event) {
      var _this$getSafeState2 = _this.getSafeState(),
          view = _this$getSafeState2.view,
          selectedValue = _this$getSafeState2.selectedValue;

      var keyPressed = event.key.toLowerCase();

      switch (keyPressed) {
        case 'arrowup':
        case 'arrowdown':
          if (_this.calendarRef) {
            event.preventDefault();
            var key = keyPressed === 'arrowup' ? 'up' : 'down';

            _this.calendarRef.navigate(key);
          }

          _this.setState({
            isOpen: true
          });

          break;

        case 'arrowleft':
        case 'arrowright':
          if (_this.calendarRef) {
            event.preventDefault();

            var _key = keyPressed === 'arrowleft' ? 'left' : 'right';

            _this.calendarRef.navigate(_key);
          }

          break;

        case 'escape':
        case 'tab':
          _this.setState({
            isOpen: false
          });

          break;

        case 'backspace':
        case 'delete':
          if (selectedValue && event.target instanceof HTMLInputElement && event.target.value.length < 1) {
            // If being cleared from keyboard, don't change behaviour
            _this.setState({
              clearingFromIcon: false
            });
          }

          break;

        case 'enter':
          if (!_this.isDateDisabled(view)) {
            _this.setState({
              inputValue: '',
              isOpen: false,
              selectedValue: view,
              value: view,
              view: view
            });

            _this.props.onChange(view);
          }

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var changedState = {
        selectedValue: '',
        value: '',
        view: _this.props.defaultValue || format(new Date(), 'YYYY-MM-DD')
      };

      if (!_this.props.hideIcon) {
        changedState = _objectSpread(_objectSpread({}, changedState), {}, {
          clearingFromIcon: true
        });
      }

      _this.setState(changedState);

      _this.props.onChange('');
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectChange", function (value, action) {
      // Used for native clear event in React Select
      // Triggered when clicking ClearIndicator or backspace with no value
      if (action.action === 'clear') {
        _this.onClear();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "refCalendar", function (ref) {
      _this.calendarRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (inputValue, actionMeta) {
      var onInputChange = _this.props.selectProps.onInputChange;

      if (onInputChange) {
        onInputChange(inputValue, actionMeta);
      }

      _this.setState({
        inputValue: inputValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getContainerRef", function (ref) {
      var oldRef = _this.containerRef;
      _this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
      // as the layered menu requires it for dimension calculation

      if (oldRef == null && ref != null) {
        _this.forceUpdate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSubtleControlStyles", function (isOpen) {
      return {
        border: "2px solid ".concat(isOpen ? B100 : "transparent"),
        backgroundColor: 'transparent',
        padding: '1px'
      };
    });

    _defineProperty(_assertThisInitialized(_this), "parseDate", function (date) {
      var _this$props = _this.props,
          parseInputValue = _this$props.parseInputValue,
          dateFormat = _this$props.dateFormat;

      if (parseInputValue) {
        return parseInputValue(date, dateFormat || defaultDateFormat);
      }

      var _this$getSafeState3 = _this.getSafeState(),
          l10n = _this$getSafeState3.l10n;

      return l10n.parseDate(date);
    });

    _defineProperty(_assertThisInitialized(_this), "formatDate", function (value) {
      var _this$props2 = _this.props,
          formatDisplayLabel = _this$props2.formatDisplayLabel,
          dateFormat = _this$props2.dateFormat;

      var _this$getSafeState4 = _this.getSafeState(),
          l10n = _this$getSafeState4.l10n;

      if (formatDisplayLabel) {
        return formatDisplayLabel(value, dateFormat || defaultDateFormat);
      }

      var date = parse(value);

      if (dateFormat) {
        return format(date, dateFormat);
      }

      return l10n.formatDate(date);
    });

    _defineProperty(_assertThisInitialized(_this), "getPlaceholder", function () {
      var placeholder = _this.props.placeholder;

      if (placeholder) {
        return placeholder;
      }

      var _this$getSafeState5 = _this.getSafeState(),
          l10n = _this$getSafeState5.l10n;

      return l10n.formatDate(placeholderDatetime);
    });

    var _getDateObj = getDateObj(new Date()),
        day = _getDateObj.day,
        _month = _getDateObj.month,
        _year = _getDateObj.year;

    _this.state = {
      isOpen: _this.props.defaultIsOpen,
      clearingFromIcon: false,
      inputValue: _this.props.selectProps.inputValue,
      selectedValue: _this.props.value || _this.props.defaultValue,
      value: _this.props.defaultValue,
      view: _this.props.value || _this.props.defaultValue || "".concat(_year, "-").concat(padToTwo(_month), "-").concat(padToTwo(day)),
      l10n: createLocalizationProvider(_this.props.locale)
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.locale !== nextProps.locale) {
        this.setState({
          l10n: createLocalizationProvider(nextProps.locale)
        });
      }
    } // All state needs to be accessed via this function so that the state is mapped from props
    // correctly to allow controlled/uncontrolled usage.

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          appearance = _this$props3.appearance,
          autoFocus = _this$props3.autoFocus,
          disabled = _this$props3.disabled,
          hideIcon = _this$props3.hideIcon,
          icon = _this$props3.icon,
          id = _this$props3.id,
          innerProps = _this$props3.innerProps,
          isDisabled = _this$props3.isDisabled,
          disabledDateFilter = _this$props3.disabledDateFilter,
          maxDate = _this$props3.maxDate,
          minDate = _this$props3.minDate,
          isInvalid = _this$props3.isInvalid,
          name = _this$props3.name,
          selectProps = _this$props3.selectProps,
          spacing = _this$props3.spacing,
          locale = _this$props3.locale,
          testId = _this$props3.testId,
          weekStartDay = _this$props3.weekStartDay;
      var BORDER_WIDTH = 2;
      var ICON_PADDING = 2;

      var _this$getSafeState6 = this.getSafeState(),
          value = _this$getSafeState6.value,
          view = _this$getSafeState6.view,
          isOpen = _this$getSafeState6.isOpen,
          inputValue = _this$getSafeState6.inputValue;

      var menuIsOpen = isOpen && !isDisabled;
      var showClearIndicator = Boolean((value || inputValue) && !hideIcon);
      var dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
      var selectComponents = {
        DropdownIndicator: dropDownIcon,
        Menu: Menu
      };

      if (!showClearIndicator) {
        selectComponents.ClearIndicator = EmptyClearIndicator;
      }

      var _selectProps$styles = selectProps.styles,
          selectStyles = _selectProps$styles === void 0 ? {} : _selectProps$styles;
      var controlStyles = appearance === 'subtle' ? this.getSubtleControlStyles(isOpen) : {};
      var disabledStyle = isDisabled ? {
        pointerEvents: 'none'
      } : {};
      var calendarProps = {
        calendarContainerRef: this.containerRef,
        calendarRef: this.refCalendar,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarValue: value && format(parse(value), 'YYYY-MM-DD'),
        calendarView: view,
        onCalendarChange: this.onCalendarChange,
        onCalendarSelect: this.onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay
      };
      return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
        role: "presentation",
        onClick: this.onInputClick,
        onInput: this.onSelectInput,
        onKeyDown: this.onSelectKeyDown,
        ref: this.getContainerRef,
        "data-testid": testId && "".concat(testId, "--container")
      }), /*#__PURE__*/React.createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && "".concat(testId, "--input")
      }), /*#__PURE__*/React.createElement(Select, _extends({
        enableAnimation: false,
        menuIsOpen: menuIsOpen,
        closeMenuOnSelect: true,
        autoFocus: autoFocus,
        instanceId: id,
        isDisabled: isDisabled,
        onBlur: this.onSelectBlur,
        onFocus: this.onSelectFocus,
        inputValue: inputValue,
        onInputChange: this.handleInputChange,
        components: selectComponents,
        onChange: this.onSelectChange,
        styles: mergeStyles(selectStyles, {
          control: function control(base) {
            return _objectSpread(_objectSpread(_objectSpread({}, base), controlStyles), disabledStyle);
          },
          indicatorsContainer: function indicatorsContainer(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              paddingLeft: ICON_PADDING,
              paddingRight: gridSize() - BORDER_WIDTH
            });
          }
        }),
        placeholder: this.getPlaceholder(),
        value: value && {
          label: this.formatDate(value),
          value: value
        }
      }, selectProps, calendarProps, {
        isClearable: true,
        spacing: spacing,
        validationState: isInvalid ? 'error' : 'default',
        testId: testId
      })));
    }
  }]);

  return DatePicker;
}(React.Component);

_defineProperty(DatePicker, "defaultProps", datePickerDefaultProps);

export { DatePicker as DatePickerWithoutAnalytics };
export default withAnalyticsContext({
  componentName: 'datePicker',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onChange: createAndFireEvent('atlaskit')({
    action: 'selectedDate',
    actionSubject: 'datePicker',
    attributes: {
      componentName: 'datePicker',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(DatePicker));